import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/logos/shopify.svg'
import _imports_1 from '@/assets/images/logos/woocommerce.svg'
import _imports_2 from '@/assets/images/logos/whatsapp.svg'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "mb-[22px]" }
const _hoisted_4 = { class: "flex items-center justify-between mb-[20px] last:mb-0" }
const _hoisted_5 = { class: "flex items-center gap-[15px]" }
const _hoisted_6 = { class: "block text-black dark:text-white font-semibold" }
const _hoisted_7 = { class: "block mt-[3px]" }
const _hoisted_8 = { class: "flex items-center justify-between mb-[20px] last:mb-0" }
const _hoisted_9 = { class: "flex items-center gap-[15px]" }
const _hoisted_10 = { class: "block text-black dark:text-white font-semibold" }
const _hoisted_11 = { class: "block mt-[3px]" }
const _hoisted_12 = {
  type: "button",
  class: "inline-block"
}
const _hoisted_13 = { class: "flex items-center justify-between mb-[20px] last:mb-0" }
const _hoisted_14 = { class: "flex items-center gap-[15px]" }
const _hoisted_15 = { class: "block text-black dark:text-white font-semibold" }
const _hoisted_16 = { class: "block mt-[3px]" }
const _hoisted_17 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
}
const _hoisted_18 = { class: "bg-white dark:bg-[#0c1427] p-6 rounded-lg shadow-lg w-full max-w-md mx-4" }
const _hoisted_19 = { class: "text-xl font-bold mb-4 text-black dark:text-white" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = { class: "block text-gray-700 dark:text-gray-300 mb-2" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "text-sm text-gray-500 dark:text-gray-400 mt-1" }
const _hoisted_25 = { class: "mb-4" }
const _hoisted_26 = { class: "block text-gray-700 dark:text-gray-300 mb-2" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = { class: "text-sm text-gray-500 dark:text-gray-400 mt-1" }
const _hoisted_29 = { class: "flex justify-end mt-6" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
}
const _hoisted_32 = { class: "bg-white dark:bg-[#0c1427] p-6 rounded-lg shadow-lg w-full max-w-md mx-4" }
const _hoisted_33 = { class: "flex flex-col items-center mb-4" }
const _hoisted_34 = {
  key: 0,
  class: "w-24 h-24 rounded-full bg-gray-200 overflow-hidden mb-3"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center"
}
const _hoisted_37 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 1,
  class: "w-48 h-48 bg-gray-200 flex items-center justify-center"
}
const _hoisted_40 = { class: "text-center text-sm mt-2" }
const _hoisted_41 = { class: "text-center font-medium text-gray-800 dark:text-gray-200 mb-1" }
const _hoisted_42 = {
  key: 2,
  class: "text-sm text-center text-gray-600 dark:text-gray-400"
}
const _hoisted_43 = { class: "flex flex-col gap-3 mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SettingsNav),
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.directT('settings.connections.subtitle')), 1),
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[10] || (_cache[10] = _createElementVNode("img", {
              src: _imports_0,
              class: "w-[40px]",
              alt: "shopify"
            }, null, -1)),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.directT('settings.connections.shopify.name')), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.directT('settings.connections.shopify.description')), 1)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "inline-block px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openShopifyForm && _ctx.openShopifyForm(...args)))
          }, _toDisplayString(_ctx.isShopifyConnected ? _ctx.directT('settings.connections.shopify.connected') : _ctx.directT('settings.connections.shopify.configure')), 1)
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[11] || (_cache[11] = _createElementVNode("img", {
              src: _imports_1,
              class: "w-[40px]",
              alt: "woocommerce"
            }, null, -1)),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.directT('settings.connections.woocommerce.name')), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.directT('settings.connections.woocommerce.description')), 1)
            ])
          ]),
          _createElementVNode("button", _hoisted_12, _toDisplayString(_ctx.directT('settings.connections.woocommerce.notConnected')), 1)
        ]),
        _createElementVNode("li", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[12] || (_cache[12] = _createElementVNode("img", {
              src: _imports_2,
              class: "w-[40px]",
              alt: "whatsapp"
            }, null, -1)),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.directT('settings.connections.whatsapp.name')), 1),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.directT('settings.connections.whatsapp.description')), 1)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "inline-block px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openWhatsappPopup && _ctx.openWhatsappPopup(...args)))
          }, _toDisplayString(_ctx.isWhatsappConnected ? _ctx.directT('settings.connections.whatsapp.connected') : _ctx.directT('settings.connections.whatsapp.configure')), 1)
        ])
      ])
    ]),
    (_ctx.shopifyFormOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.directT('settings.connections.shopify.configTitle')), 1),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.directT('settings.connections.shopify.webhookUrl')), 1),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("input", {
                  type: "text",
                  class: "block w-full px-4 py-2 border border-gray-300 dark:border-gray-700 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-md cursor-not-allowed",
                  value: _ctx.webhookUrl,
                  readonly: ""
                }, null, 8, _hoisted_23),
                _createElementVNode("button", {
                  class: "ml-2 px-3 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-md",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args)))
                }, _toDisplayString(_ctx.directT('settings.connections.shopify.copy')), 1)
              ]),
              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.directT('settings.connections.shopify.webhookUrlHint')), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.directT('settings.connections.shopify.webhookSigningSecret')), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.webhookSign) = $event)),
                class: "block w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500",
                placeholder: _ctx.directT('settings.connections.shopify.webhookSigningSecret')
              }, null, 8, _hoisted_27), [
                [_vModelText, _ctx.webhookSign]
              ]),
              _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.directT('settings.connections.shopify.webhookSigningSecretHint')), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                class: "px-4 py-2 bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-white rounded-md mr-2",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeShopifyForm && _ctx.closeShopifyForm(...args)))
              }, _toDisplayString(_ctx.directT('settings.connections.cancel')), 1),
              _createElementVNode("button", {
                class: "px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveShopifyConfig && _ctx.saveShopifyConfig(...args))),
                disabled: !_ctx.webhookSign
              }, _toDisplayString(_ctx.directT('settings.connections.save')), 9, _hoisted_30)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.whatsappPopupOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "text-xl font-bold mb-4 text-black dark:text-white" }, "WhatsApp", -1)),
            _createElementVNode("div", _hoisted_33, [
              (!_ctx.showQrCode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    (_ctx.whatsappProfilePicture)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.whatsappProfilePicture,
                          alt: "WhatsApp Profile",
                          class: "w-full h-full object-cover"
                        }, null, 8, _hoisted_35))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, _cache[13] || (_cache[13] = [
                          _createElementVNode("img", {
                            src: _imports_2,
                            alt: "WhatsApp",
                            class: "w-12 h-12"
                          }, null, -1)
                        ])))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showQrCode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    (_ctx.whatsappQrCodeData)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.whatsappQrCodeData,
                          alt: "WhatsApp QR Code",
                          class: "w-48 h-48"
                        }, null, 8, _hoisted_38))
                      : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.directT('settings.connections.whatsapp.loadingQR')), 1)
                        ])),
                    _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.directT('settings.connections.whatsapp.scanQrInstructions')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.whatsappStatus || _ctx.directT('settings.connections.whatsapp.notConnected')), 1),
              (_ctx.whatsappInstanceId)
                ? (_openBlock(), _createElementBlock("p", _hoisted_42, " Instance ID: " + _toDisplayString(_ctx.whatsappInstanceId), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_43, [
              (!_ctx.showQrCode)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "px-4 py-2 text-white rounded-md w-full flex items-center justify-center",
                    style: {"background-color":"#3b82f6","color":"white"},
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getWhatsappQRCode && _ctx.getWhatsappQRCode(...args)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.directT('settings.connections.whatsapp.getQRCode')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isWhatsappConnected && !_ctx.showQrCode)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "px-4 py-2 text-white rounded-md w-full flex items-center justify-center",
                    style: {"background-color":"#ef4444","color":"white"},
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.disconnectWhatsapp && _ctx.disconnectWhatsapp(...args)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.directT('settings.connections.whatsapp.disconnect')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "px-4 py-2 bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-white rounded-md w-full mt-2",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeWhatsappPopup && _ctx.closeWhatsappPopup(...args)))
              }, _toDisplayString(_ctx.directT('settings.connections.cancel')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.toastMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["fixed bottom-4 right-4 left-4 md:left-auto md:max-w-md p-4 bg-gray-800 text-white rounded-md shadow-lg transform transition-transform duration-300 z-50 flex items-center justify-between", { 'bg-green-600': _ctx.toastType === 'success', 'bg-red-600': _ctx.toastType === 'error', 'bg-blue-600': _ctx.toastType === 'info' }])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.toastMessage), 1),
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args))),
            class: "ml-4 text-white hover:text-gray-300"
          }, "×")
        ], 2))
      : _createCommentVNode("", true)
  ]))
}